import useRequest from '@/websdk/utils/request';

export default (function () {
  const { data, exec } = useRequest({
    name: 'GET_ROLE_LIST',
    url: '/api/system/roles',
    manual: false,
  });
  return [data || [], exec];
});
